import LottieClient from "../LottieClient/LottieClient";
import lottie from "./loading-lottie.json";
export default function LoadingLottie() {
	return (
		<div className='h-[400px] mt-12  flex items-center justify-center'>
			<LottieClient animation={lottie} autoPlay={ true } />
		</div>
	);
}
